import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudCpeService } from '../datosbasicos/cpe.service';
import { ProductosCpeService } from './productosCpe.service';
import { SolicitudCpeProductosViewModel, TwProductoCertificadoPrevioExViewModel } from './productosCpe.types';

@Component({
    selector: 'app-productoscpe-list',
    templateUrl: './productosCpe-list.component.html',
})
export class ProductosCpeListComponent extends ComponentBase implements OnInit {
    editMode: boolean = false;
    editTitle: string = 'Nuevo';

    solicitudCpeProductos: SolicitudCpeProductosViewModel;
    productosCpeCollection: TwProductoCertificadoPrevioExViewModel[];
    tituloEstadoSolicitud: string;
    IdEstadoSolicitudCpe: number;
    codigoCpe: string;
    habilitarGuardar: boolean = true;
    habilitarNuevoProducto: boolean = true;
    habilitarEdicion: boolean = true;
    //visibilitySpinner: boolean = false;

    numeroProductos: number = 0;

    productoEditable: boolean;
    productoBorrable: boolean;

    colsProds: any[];

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private navMenuService: NavMenuService,
        private cpeService: SolicitudCpeService,
        private productosCpeService: ProductosCpeService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        let id = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(id);

        if (id) {
            this.productosCpeService.getSolicitudProductosCpe(id).subscribe(result => {
                this.solicitudCpeProductos = result;
                this.tituloEstadoSolicitud = this.solicitudCpeProductos.IdEstadoSolicitudCpeDescripcion;
                this.IdEstadoSolicitudCpe = this.solicitudCpeProductos.IdEstadoSolicitudCpe;
                this.codigoCpe = this.solicitudCpeProductos.Codigo;

                this.productosCpeCollection = this.solicitudCpeProductos.TwProductoCertificadoPrevioExCollection;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_CPE,
                    this.solicitudCpeProductos.IdEstadoSolicitudCpe,
                    undefined,
                ).Visible;
                this.habilitarNuevoProducto = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.MENU_PRODUCTOS_CPE,
                    this.solicitudCpeProductos.IdEstadoSolicitudCpe,
                    undefined,
                ).Editable;
                this.habilitarEdicion = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.MENU_PRODUCTOS_CPE,
                    this.solicitudCpeProductos.IdEstadoSolicitudCpe,
                ).Editable;

                //this.updateForm();

                this.numeroProductos = this.solicitudCpeProductos.TwProductoCertificadoPrevioExCollection.length;

                if (!this.habilitarEdicion) {
                    //metodo para deshabilitar los controles
                    //this.DisableControlsConsulta();
                    this.habilitarGuardar = false;
                }

                this.productoEditable = this.checkEdit();
                this.productoBorrable = this.checkDelete();
            });
        }

        this.colsProds = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'IdBotanicaDescripcion', header: 'Nom Cientí­fico' },
            { field: 'CodigoTaric', header: 'Cód. Taric' },
            { field: 'CodigoEppo', header: 'Cód. EPPO' },
            { field: 'NombreComun', header: 'Nombre Común' },
            { field: 'Grupo', header: 'Grupo' },
            { field: 'IdFormaDescripcion', header: 'Forma' },
            { field: 'Peso', header: 'Peso' },
            { field: 'UnidadMedidaPeso', header: 'Unidad peso' },
            { field: 'Unidades', header: 'Unidades (Ud)' },
            { field: 'Volumen', header: 'Volumen (m³)' },
        ];
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudCpe.Id) || this.navMenuService.currentSolicitudCpe.Id !== id) {
            this.cpeService.getSolicitudCpe(id).subscribe(result => {
                this.navMenuService.currentSolicitudCpe = result;
            });
        }
    }

    checkEdit() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_PRODUCTOS_CPE, this.solicitudCpeProductos.IdEstadoSolicitudCpe).Editable;
    }

    checkDelete() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_PRODUCTOS_CPE, this.solicitudCpeProductos.IdEstadoSolicitudCpe).Editable;
    }

    onAdd() {
        this.router.navigate(['/exportacion/cpe/productos/', this.solicitudCpeProductos.Id, 'create']);
    }

    onEdit(item: SolicitudCpeProductosViewModel) {
        this.router.navigate(['/exportacion/cpe/productos', this.solicitudCpeProductos.Id, 'producto', item.Id]);
    }

    onDelete(item: TwProductoCertificadoPrevioExViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.productosCpeService.deleteProductoCpe(item.Id).subscribe(() => {
                    this.addSuccessMessage('Producto eliminado correctamente');
                    this.ngOnInit();
                });
            },
        });
    }
}
